import React from 'react';
export function EditorSpellcheckIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.984 4.821c-.823-.89-2.278-1.133-3.47-.67C17.19 4.664 16.25 5.977 16.25 8c0 1.027.217 1.885.634 2.56a3.163 3.163 0 001.662 1.344c1.217.424 2.625.09 3.411-.697a1 1 0 00-1.414-1.414c-.214.214-.806.408-1.339.223a1.164 1.164 0 01-.62-.51c-.176-.284-.334-.754-.334-1.506 0-1.341.56-1.819.987-1.985.557-.216 1.102-.027 1.279.164a1 1 0 101.468-1.358zM4.25 4a1 1 0 00-.97.757l-1.5 6a1 1 0 101.94.486l.186-.743h2.188l.186.742a1 1 0 101.94-.485l-1.5-6A1 1 0 005.75 4h-1.5zM5 6.123L5.594 8.5H4.406L5 6.123zM9.25 5a1 1 0 011-1h2.5a2.5 2.5 0 012 4 2.5 2.5 0 01-2 4h-2.5a1 1 0 01-1-1V5zm2 4v1h1.5a.5.5 0 000-1h-1.5zm1.5-2a.5.5 0 000-1h-1.5v1h1.5zM17.707 15.707a1 1 0 00-1.414-1.414L11 19.586l-2.293-2.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l6-6z"
  }));
}